<template>
    <div class="login-page" :class="{ dark: isDark }">

<!--        <div class="login__theme">-->
<!--            <button class="login__theme-btn" @click="toggleTheme">-->
<!--                <span class="icon">{{ isDark ? '🌙' : '☀️' }}</span>-->
<!--                <span>{{ isDark ? 'Dark mode' : 'Light mode' }}</span>-->
<!--            </button>-->
<!--        </div>-->

        <div class="login">

            <div class="login__header">
                <h1 class="login__title">CRM</h1>
                <p class="login__subtitle">Sign in to your account</p>
            </div>

            <div class="login__card">

                <div v-if="error" class="login__error">
                    <svg viewBox="0 0 24 24">
                        <circle cx="12" cy="12" r="10"/>
                        <line x1="12" y1="8" x2="12" y2="12"/>
                        <line x1="12" y1="16" x2="12.01" y2="16"/>
                    </svg>
                    <span>{{ error }}</span>
                </div>

                <div class="field">
                    <label class="field__label" for="login-email">Email</label>
                    <div class="field__input-wrap">
                        <input
                            ref="emailInput"
                            v-model.trim="email"
                            class="field__input"
                            :class="{ 'field__input--error': errors.email }"
                            id="login-email"
                            type="email"
                            placeholder="user@example.com"
                            autocomplete="email"
                            @keydown.enter="focusPassword"
                            @input="clearFieldError('email')"
                        >
                    </div>
                </div>

                <div class="field">
                    <label class="field__label" for="login-password">Password</label>
                    <div class="field__input-wrap">
                        <input
                            ref="passwordInput"
                            v-model="password"
                            class="field__input"
                            :class="{ 'field__input--error': errors.password }"
                            id="login-password"
                            :type="showPassword ? 'text' : 'password'"
                            placeholder="Enter your password"
                            autocomplete="current-password"
                            @keydown.enter="submit"
                            @input="clearFieldError('password')"
                        >
                        <button
                            class="field__toggle"
                            type="button"
                            :title="showPassword ? 'Hide password' : 'Show password'"
                            @click="showPassword = !showPassword"
                        >
                            <svg v-if="!showPassword" viewBox="0 0 24 24">
                                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                                <circle cx="12" cy="12" r="3"/>
                            </svg>
                            <svg v-else viewBox="0 0 24 24">
                                <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94"/>
                                <path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19"/>
                                <path d="M14.12 14.12a3 3 0 11-4.24-4.24"/>
                                <line x1="1" y1="1" x2="23" y2="23"/>
                            </svg>
                        </button>
                    </div>
                </div>

                <button
                    class="login__submit"
                    :class="{ 'login__submit--loading': loading }"
                    :disabled="loading"
                    type="button"
                    @click="submit"
                >
                    Sign In
                </button>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LoginPage',

    data() {
        return {
            logo         : window.imagesURL + '/logo.webp',
            email        : '',
            password     : '',
            showPassword : false,
            loading      : false,
            error        : '',
            isLight      : false,
            errors       : {
                email    : false,
                password : false,
            },
        }
    },

    mounted() {
        this.$refs.emailInput.focus();

        try {
            this.isLight = localStorage.getItem( 'flowadmin-admin-theme' ) === 'light';
        } catch( e ) {}
    },

    methods: {

        // toggleTheme() {
        //     this.isLight = !this.isLight;
        //
        //     document.body.classList.toggle( 'light-theme', this.isLight );
        //
        //     try {
        //         localStorage.setItem( 'flowadmin-admin-theme', this.isLight ? 'light' : 'dark' );
        //     } catch( e ) {}
        // },

        isValidEmail( email ) {
            return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test( email );
        },

        validate() {
            this.errors.email    = false;
            this.errors.password = false;

            if( ! this.email ) {
                this.error = 'Please enter your email';
                this.errors.email = true;
                this.$refs.emailInput.focus();
                return false;
            }

            if( ! this.isValidEmail( this.email ) ) {
                this.error = 'Please enter a valid email';
                this.errors.email = true;
                this.$refs.emailInput.focus();
                return false;
            }

            if( ! this.password ) {
                this.error = 'Please enter your password';
                this.errors.password = true;
                this.$refs.passwordInput.focus();
                return false;
            }

            return true;
        },

        clearFieldError( field ) {
            this.errors[ field ] = false;
            if( this.error )
                 this.error = '';
        },

        focusPassword() {
            this.$refs.passwordInput.focus();
        },

        async submit() {
            if( !this.validate() || this.loading ) return;

            this.loading = true;
            this.error   = '';

            try {
                const response = await this.$http.post('/auth/login', {
                    email    : this.email,
                    password : this.password,
                });

                const { status, data } = response?.data || {};
                if( status === 'success' && data.token ) {
                    document.cookie = `${window.auth_token}=${data.token}; path=/; max-age=86400; secure; samesite=strict`;
                    if( data.redirect )
                        window.location.href = data.redirect;
                } else {
                    this.error = data.message || 'Authorization failed';
                }

            } catch( e ) {
                console.log(e.response);
                const msg = e.response?.data?.data?.message;
                this.error = msg || 'Server is unavailable, please try again later';
            } finally {
                this.loading = false;
            }
        },
    },
}
</script>

<style scoped>

</style>